import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

interface IGetAccessCode {
    id?: number;
    access_code?: number;
    limit?: number;
    offset?: number;
}

interface IPostAccessCode {
    access_code?: string;
    start_date: string;
    end_date: string;
    open_time?: string;
    days_in_advance: number;
    active: boolean;
}

interface IPutAccessCode extends IPostAccessCode {
  id: number;
}

export interface ITeeTimeAccessCode {
    id: number;
    access_code: string;
    start_date: string;
    end_date: string;
    open_time: string;
    days_in_advance: number;
    active: boolean;
}

export async function GetTeeTimeAccessCodes(params: IGetAccessCode, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet<ITeeTimeAccessCode[]>(
      APIUrl(AdminType.FacilityAdmin, "/tee-sheet/tee-time/access-code"),
      params,
      useGlobalLoader,
      token,
    );
  }

  export async function PostTeeTimeAccessCode(params: IPostAccessCode, useGlobalLoader: boolean) {
    return await APIPost(
      APIUrl(AdminType.FacilityAdmin, "/tee-sheet/tee-time/access-code"),
      params,
      useGlobalLoader,
    );
  }

  export async function PutTeeTimeAccessCode(params: IPutAccessCode, useGlobalLoader: boolean) {
    return await APIPut(
      APIUrl(AdminType.FacilityAdmin, "/tee-sheet/tee-time/access-code"),
      params,
      useGlobalLoader,
    );
  }

    export async function DeleteTeeTimeAccessCode(params: {id: number}, useGlobalLoader: boolean) {
      return await APIDelete(
        APIUrl(AdminType.FacilityAdmin, "/tee-sheet/tee-time/access-code"),
        params,
        useGlobalLoader,
      );
  }